<template>
    <div>
        <top-header></top-header>
        <slot />
    </div>
</template>

<script>
    import TopHeader from '@/components/layout/Header.vue';
    export default {
        components: { TopHeader }
    }
</script>